import { Router, Route } from 'wouter-preact';

// Pages
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';

// Components
import { AppDetailDialog } from './components/AppDetailDialog';

// Context
import { AppsProvider } from './contexts/AppsContext';
import { UserProvider } from './contexts/UserContext';

export function App() {
  return (
    <UserProvider>
      <AppsProvider>
        <div class="w-full h-full col bg-black/20">
          <main class="flex-1">
            <Router>
              <Route path="/">
                <HomePage />
              </Route>
              <Route path="/apps/:id">
                <AppDetailDialog />
              </Route>
              <Route path="/auth">
                <LoginPage />
              </Route>
            </Router>
          </main>
          {/* <Footer /> */}
        </div>
      </AppsProvider>
    </UserProvider>
  );
}
